import PropTypes from 'prop-types';
import {
    List,
    ListItemText,
    Box,
    Avatar,
    Divider,
    Grid2 as Grid,
    Typography
} from '@mui/material';
import { useState } from 'react';
import { EditButton } from '../../../component/buttons';
import { CommonCard } from '../../../component/cards/MainCard2';

const PersonalData = ({ user }) => {
    const [role, setRole] = useState(0);

    return (
        <CommonCard sx={{ p: 2 }}>
            <Grid container spacing={2}>
                <Grid size={'auto'}>
                    <Avatar
                        src={user?.picture || ''}
                        style={{
                            width: '120px',
                            height: '120px',
                            backgroundColor: '#01579B',
                            color: '#FFFFFF99'
                        }}
                    />
                </Grid>
                <Grid size={'grow'}>
                    <Typography variant="h4">DADOS PESSOAIS</Typography>
                    <Divider sx={{ mt: 1 }} />
                    <List>
                        <ListItemText
                            primary={
                                <>
                                    <Typography variant="h4" component="span">
                                        NOME:{' '}
                                    </Typography>
                                    <Typography variant="body1" component="span">
                                        {user.name}
                                    </Typography>
                                </>
                            }
                        />
                        <ListItemText
                            primary={
                                <>
                                    <Typography variant="h4" component="span">
                                        DATA DE NASCIMENTO:{' '}
                                    </Typography>
                                    <Typography variant="body1" component="span">
                                        {user.birth_date}
                                    </Typography>
                                </>
                            }
                        />
                        <ListItemText
                            primary={
                                <>
                                    <Typography variant="h4" component="span">
                                        GÉNERO:{' '}
                                    </Typography>
                                    <Typography variant="body1" component="span">
                                        {user.gender}
                                    </Typography>
                                </>
                            }
                        />
                        <ListItemText
                            primary={
                                <>
                                    <Typography variant="h4" component="span">
                                        SEXO:{' '}
                                    </Typography>
                                    <Typography variant="body1" component="span">
                                        {user.sex}
                                    </Typography>
                                </>
                            }
                        />
                    </List>
                    <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                        <EditButton link={''} name="Editar" size="small" />
                    </Box>
                    <Box sx={{ height: 16 }} />
                    <Typography variant="h4">LOCALIZAÇÃO</Typography>
                    <Divider sx={{ mt: 1 }} />
                    <List>
                        <ListItemText
                            primary={
                                <>
                                    <Typography variant="h4" component="span">
                                        MORADA:{' '}
                                    </Typography>
                                    <Typography variant="body1" component="span">
                                        {user.roles[role].address.street}
                                    </Typography>
                                </>
                            }
                        />
                        <ListItemText
                            primary={
                                <>
                                    <Typography variant="h4" component="span">
                                        CÓDIGO POSTAL:{' '}
                                    </Typography>
                                    <Typography variant="body1" component="span">
                                        {user.roles[role].address.zip}
                                    </Typography>
                                </>
                            }
                        />
                        <ListItemText
                            primary={
                                <>
                                    <Typography variant="h4" component="span">
                                        CIDADE:{' '}
                                    </Typography>
                                    <Typography variant="body1" component="span">
                                        {user.roles[role].address.city}
                                    </Typography>
                                </>
                            }
                        />
                        <ListItemText
                            primary={
                                <>
                                    <Typography variant="h4" component="span">
                                        PAÍS:{' '}
                                    </Typography>
                                    <Typography variant="body1" component="span">
                                        {user.roles[role].address.country}
                                    </Typography>
                                </>
                            }
                        />
                    </List>
                    <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                        <EditButton link={''} name="Editar" size="small" />
                    </Box>
                </Grid>
            </Grid>
        </CommonCard>
    );
};

PersonalData.propTypes = {
    user: PropTypes.object
};

export default PersonalData;
